import React from 'react';
import styled from 'styled-components';
import { Button, ClearIcon } from '@commonsku/styles';
import { ClearFiltersButtonProps } from './types';

const ClearAllButton = styled(Button)`
  align-items: center;
  justify-content: center;
`;

const ClearFiltersButton: React.FC<ClearFiltersButtonProps> = ({ canClear, onClear }) => {
  if (!canClear) {
    return null;
  }

  return (
    <ClearAllButton
      onClick={onClear}
      variant='secondary'
      size='medium'
      inline_flex
    >
      <ClearIcon /> Clear All
    </ClearAllButton>
  );
};

export default ClearFiltersButton;
